import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export function filterDialogResult<T>(): OperatorFunction<T | null | undefined, T> {
  return filter((value): value is T => value !== null && value !== undefined);
}
